// extracted by mini-css-extract-plugin
module.exports = {"list":"e336fd7528--list--p2nBS","buttons":"e336fd7528--buttons--SEtlT","desktop":"e336fd7528--desktop--wvGEj","promo-text":"e336fd7528--promo-text--ZyPZA"};